import { Box, Button } from '@mui/material';
import React, { useState } from 'react';
import useSnackbarContext from 'v2/components/Snackbar/useSnackbarContext';
import { useWizardStepContext } from 'v2/components/WizardModal';
import useTenantLegalDocuments from 'v2/hooks/onboarding/useTenantLegalDocuments/useTenantLegalDocuments';
import Rules from './Rules';

const STEP_INDEX = 1;

const AcceptLegalDocumentsDPAStep: React.FC<React.PropsWithChildren> = () => {
  const { showSnackbar } = useSnackbarContext();
  const handleFetchError = (errorMessage: string) => showSnackbar(errorMessage, { severity: 'error' });
  const { tenantLegalDocuments, acceptedLegalDocuments, acceptedLegalDocumentsLoading } = useTenantLegalDocuments({
    handleFetchError
  });
  const { setFooterContent, goToNext, steps } = useWizardStepContext();

  const [isDPACheckBoxSelected, setIsDPACheckBoxSelected] = useState(false);

  const handleDPACheckBoxClick = () => {
    setIsDPACheckBoxSelected(!isDPACheckBoxSelected);
  };

  const handleDPAButtonOnClick = async () => {
    if (!acceptedLegalDocumentsLoading && tenantLegalDocuments) {
      await acceptedLegalDocuments({
        dpa: tenantLegalDocuments.dpa.id,
        sla: tenantLegalDocuments.sla.id
      });
      goToNext();
    }
  };

  React.useLayoutEffect(() => {
    setFooterContent(
      STEP_INDEX,
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column-reverse', md: 'row' }, gap: 2 }}>
        <Button
          key="device-group-name-step-submit"
          id="accept-dpa-button"
          variant="contained"
          type="submit"
          disabled={!isDPACheckBoxSelected}
          loading={acceptedLegalDocumentsLoading}
          onClick={() => handleDPAButtonOnClick()}
        >
          Accept DPA
        </Button>
      </Box>
    );
  }, [acceptedLegalDocumentsLoading, setFooterContent, steps, isDPACheckBoxSelected]);

  return (
    <Rules
      title="ATLAS Access — Data Processing Agreement"
      rulesContent={tenantLegalDocuments?.dpa.currentText ?? ''}
      rulesName="Data Processing Agreement (DPA)"
      isCheckBoxChecked={isDPACheckBoxSelected}
      handleCheckBoxOnClick={handleDPACheckBoxClick}
      isLoading={!tenantLegalDocuments}
      checkboxId="accept-dpa-checkbox"
    />
  );
};

export default AcceptLegalDocumentsDPAStep;
